import { FC, Fragment } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
        },
        wrapper: {
            display: 'flex',
            position: 'relative',
            alignItems: 'center'
        },
        fabProgress: {
            color: theme.palette.common.white,
            position: 'absolute',
            top: 4,
            left: 4,
            zIndex: 1,
        }
    }),
);

interface FabLoaderProps {
    loading: boolean;
    size?: number;
    className?: string;
    variant?: "determinate" | undefined;
    value?: number;
}

export const FabLoader: FC<FabLoaderProps> = (props) => {
    const { loading, children, size, className, variant, value } = props;
    const classes = useStyles();
    return (
        <Box className={classes.root} >
            <div className={classes.wrapper}>
                {(variant !== "determinate" || !loading) &&
                    children
                }
                {loading &&
                    <Fragment>
                        <CircularProgress variant={variant} size={size ?? 56} className={className ?? classes.fabProgress} value={value} />
                        {variant === "determinate" &&
                            <Typography
                                variant="caption"
                                color="textSecondary"
                                component="span"
                            >
                                {value}%
                            </Typography>
                        }
                    </Fragment>
                }
            </div>
        </Box>
    );
}